export type WizardSource = 'filter' | 'property' | 'client';
export type WizardStep = 'source' | 'filters' | 'results';
export type SearchStatus = 'pending' | 'running' | 'completed' | 'failed';

export interface SearchParams {
  city: string;
  neighbourhood?: string;
  property_type?: string;
  transaction?: string;
  bedrooms?: number;
  price_min?: number;
  price_max?: number;
  portals?: string[];
}

export interface PartnershipResult {
  url: string;
  title: string;
  price: number | null;
  area_m2: number | null;
  bedrooms: number | null;
  bathrooms: number | null;
  parking: number | null;
  description: string | null;
  images: string[];
  city: string | null;
  neighbourhood: string | null;
  contact_name: string | null;
  whatsapp_number: string | null;
  phone_numbers: string[];
  email?: string | null;
  creci: string | null;
  advertiser_type: string | null;
  source: string | null;
  /** Internal parse strategy (ld_json / dom_fallback) — debug only, never rendered. */
  parse_strategy?: string | null;
  score: number | null;
}

export type PartnershipsWizardState = {
  step: WizardStep;
  setStep: (step: WizardStep) => void;

  source: WizardSource;
  setSource: (source: WizardSource) => void;

  referenceId: string | null;
  setReferenceId: (id: string | null) => void;

  referenceLabel: string | null;
  setReferenceLabel: (label: string | null) => void;

  seededFilters: Partial<SearchParams>;
  setSeededFilters: (filters: Partial<SearchParams>) => void;

  lastParams: Partial<SearchParams>;
  setLastParams: (params: Partial<SearchParams>) => void;

  results: PartnershipResult[];
  loading: boolean;
  error: string | null;
  /** The server answered 402 trial_quota_exhausted: show the trial block. */
  trialQuotaExhausted: boolean;
  searched: boolean;

  searchId: string | null;
  searchStatus: SearchStatus | null;
  agenciesFound: number;
  propertiesRetrieved: number;

  runSearch: (params: SearchParams, agencyId: string) => Promise<void>;
  pollSearch: (agencyId: string, searchId: string) => void;
  stopPolling: () => void;
  reset: () => void;
};

export const INITIAL_SEARCH = {
  results: [] as PartnershipResult[],
  loading: false,
  error: null as string | null,
  trialQuotaExhausted: false,
  searched: false,
  searchId: null as string | null,
  searchStatus: null as SearchStatus | null,
  agenciesFound: 0,
  propertiesRetrieved: 0,
};

export const INITIAL_WIZARD = {
  step: 'source' as WizardStep,
  source: 'filter' as WizardSource,
  referenceId: null as string | null,
  referenceLabel: null as string | null,
  seededFilters: {} as Partial<SearchParams>,
  lastParams: {} as Partial<SearchParams>,
  ...INITIAL_SEARCH,
};
